"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editProfileThunk = void 0;
const actions_1 = require("../../exportedStore/loader/actions");
const axios_1 = __importDefault(require("../../../utils/axios"));
const actions_2 = require("../../exportedStore/auth/actions");
const axios_2 = require("axios");
const editProfileThunk = ({ data, shouldRedirect, setIsLoading, setIsSuccess: setIsSuccess, setErrors }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    setIsLoading(true);
    axios_1.default
        .post("/api/v1/users/profile/update_profile/", data)
        .then((res) => {
        dispatch((0, actions_2.setUser)(res.data));
        setIsSuccess(true);
        if (shouldRedirect) {
            window.location.replace("/");
        }
    })
        .catch((err) => {
        if ((0, axios_2.isAxiosError)(err)) {
            setErrors(err.response.data);
            return;
        }
        console.log(err);
    })
        .finally(() => {
        dispatch((0, actions_1.setLoading)(false));
        setIsLoading(false);
    });
});
exports.editProfileThunk = editProfileThunk;
